import { render, staticRenderFns } from "./DamEdit.vue?vue&type=template&id=c5bc74d8&"
import script from "./DamEdit.vue?vue&type=script&lang=js&"
export * from "./DamEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports